import React from 'react'

const TableBody = ({ children }: { children: React.ReactNode }) => {
  return <tbody className="table-body">{children}</tbody>
}

export default TableBody
